import React, { useEffect, useState } from 'react';
import axios from 'axios';
import flashMessage from './HelperFunctions';
import { Alert, Button } from './ui/Primitives';
import './RecordingSettingsModal.css';

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}` });

export default function RecordingSettingsModal({ initialSettings, onClose, onSaved }) {
  const [settings, setSettings] = useState(initialSettings);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => setSettings(initialSettings), [initialSettings]);
  if (!settings) return null;

  async function save(event) {
    event.preventDefault();
    setIsSaving(true);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_HOST}/v2/calls/recording-settings`,
        {
          enabled: Boolean(settings.enabled),
          disclosure: settings.disclosure || '',
          retentionDays: Number(settings.retentionDays),
          access: settings.access,
        },
        { headers: authHeaders() },
      );
      onSaved(response.data.settings);
      flashMessage('success', 'Recording settings updated');
      onClose();
    } catch (error) {
      flashMessage('error', error.response?.data?.error?.message || 'Recording settings could not be updated');
    } finally {
      setIsSaving(false);
    }
  }

  return <div className="modal-overlay" onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
    <form className="modal-content recording-settings-modal" onSubmit={save}>
      <span className="say-eyebrow">Calls</span>
      <h2>Recording settings</h2>
      <p>Choose whether Sayable records calls and who can listen afterward.</p>
      <label className="recording-settings-toggle">
        <input type="checkbox" checked={Boolean(settings.enabled)} onChange={event => setSettings(current => ({ ...current, enabled: event.target.checked }))} />
        <span><strong>Record customer calls</strong><small>Sayable plays the notice before recording begins.</small></span>
      </label>
      <label className="recording-settings-field">
        <span>Recording notice</span>
        <input className="modal-input" maxLength="240" value={settings.disclosure || ''} disabled={!settings.enabled} onChange={event => setSettings(current => ({ ...current, disclosure: event.target.value }))} />
      </label>
      <div className="recording-settings-grid">
        <label className="recording-settings-field"><span>Keep new recordings</span><select className="say-select" value={settings.retentionDays} disabled={!settings.enabled} onChange={event => setSettings(current => ({ ...current, retentionDays: Number(event.target.value) }))}><option value="30">30 days</option><option value="90">90 days</option><option value="180">180 days</option></select></label>
        <label className="recording-settings-field"><span>Who can listen</span><select className="say-select" value={settings.access} disabled={!settings.enabled} onChange={event => setSettings(current => ({ ...current, access: event.target.value }))}><option value="admins">Administrators</option><option value="all_members">All active members</option></select></label>
      </div>
      <Alert tone="info" title="Use recordings responsibly">Recording requirements vary by location and industry. Make sure this notice and your use of recordings meet the requirements that apply to your business.</Alert>
      <div className="say-dialog-actions"><Button variant="secondary" type="button" onClick={onClose}>Cancel</Button><Button type="submit" loading={isSaving} loadingLabel="Saving…">Save settings</Button></div>
    </form>
  </div>;
}
